import classNames from 'classnames';
import { Component, MouseEvent, ReactNode } from 'react';
import './react-ui-add-button.scss';
import Button from './react-ui-button';

interface Props {
  label?: ReactNode;
  children?: ReactNode;
  disabled?: boolean;
  onClick?: (mouseEvent: MouseEvent) => void;
  testid?: string;
}

export default class AddButton extends Component<Props> {
  public static demoProps = [
    {
      label: 'Demo add button',
      onClick: () => null,
    },
    {
      disabled: true,
      label: 'Demo add button (disabled)',
      onClick: () => null,
    },
  ];

  public static defaultProps = {
    disabled: false,
  };

  public render() {
    const { disabled, onClick, testid, children, label } = this.props;
    return (
      <Button
        disabled={disabled}
        onClick={onClick}
        className={classNames('AddButton', {
          'AddButton--disabled': disabled,
        })}
        testid={testid}
      >
        <i className="mdi mdi-plus-circle" />
        {children || label}
      </Button>
    );
  }
}
